import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

declare var echarts;

@Component({
  selector: 'app-barchart',
  templateUrl: './barchart.component.html',
  styleUrls: ['./barchart.component.scss']
})
export class BarchartComponent implements AfterViewInit {

  @Input() public data: Array<Number> =[];
  @Input() public height: string;
  @ViewChild('main') main: ElementRef;
  public loading: boolean = true;
  private chart: any = null;
  constructor(private cd: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.loading = false;
      this.cd.detectChanges();
      this.chart = echarts.init(this.main.nativeElement, {}, {
        devicePixelRatio: window.devicePixelRatio,
        width: 'auto'
      });

      let chart_data = [0, 0, 0, 0, 0, 0, 0];
  
      this.data.forEach((d, index) => {
        chart_data[index] = parseFloat(d.toFixed(2));
      });
  
      let options = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          show: false
        },
        yAxis: {
          type: 'value',
          show: false
        },
        series: [
          {
            data: chart_data,
            type: 'bar',
          }
        ]
      };
      this.chart.setOption(options);
    }, 500);
  }

}
